<!-- Feedback & Quality Widget (admin-only) -->
<div class="rounded-[24px] bg-white shadow-[0px_4px_10px_rgba(20,31,71,0.08)] p-9 flex flex-col gap-6 min-w-0">
    <!-- Header -->
    <div class="flex items-center gap-2 widget-title text-gray-900">
        <span>Feedback &amp; Quality</span>
        <i class="pi pi-info-circle text-xs text-gray-400"
            pTooltip="Aggregated workspace-wide feedback for Bob across every surface and feature"
            tooltipPosition="top"></i>
    </div>

    <!-- Two-column body: stat cluster (left) + per-feature bars (right) -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 min-w-0">
        <!-- Stat cluster -->
        <div class="grid grid-cols-3 gap-3 min-w-0">
            <!-- Positive sentiment ring -->
            <div class="flex flex-col items-center justify-center text-center col-span-3 sm:col-span-1">
                <svg viewBox="0 0 100 100" class="w-24 h-24" aria-hidden="true">
                    <circle cx="50" cy="50" [attr.r]="ringRadius" fill="none" stroke="#E5E7EB" stroke-width="10"/>
                    <circle cx="50" cy="50" [attr.r]="ringRadius" fill="none" stroke="#10B981" stroke-width="10"
                        stroke-linecap="round" transform="rotate(-90 50 50)"
                        [attr.stroke-dasharray]="ringCircumference"
                        [attr.stroke-dashoffset]="ringOffset()"/>
                    <text x="50" y="55" text-anchor="middle" class="text-sm font-bold" fill="#111827">
                        {{ data()?.positiveSentimentPct ?? 0 }}%
                    </text>
                </svg>
                <div class="text-xs text-gray-500 mt-1">Positive sentiment</div>
            </div>

            <!-- NPS -->
            <div class="rounded-lg bg-gray-50 p-3 flex flex-col items-center justify-center outline outline-1 outline-gray-100">
                <div class="text-2xl font-bold text-gray-900">{{ data()?.npsScore ?? 0 }}</div>
                <div class="text-xs text-gray-500 text-center mt-1">NPS</div>
            </div>

            <!-- Average rating + stars -->
            <div class="rounded-lg bg-gray-50 p-3 flex flex-col items-center justify-center outline outline-1 outline-gray-100">
                <div class="text-2xl font-bold text-gray-900">{{ data()?.avgRating ?? 0 }}</div>
                <div class="flex gap-0.5 mt-1">
                    <ng-container *ngFor="let star of stars()">
                        <i *ngIf="star === 'full'" class="pi pi-star-fill text-amber-400 text-xs"></i>
                        <i *ngIf="star === 'half'" class="pi pi-star-half text-amber-400 text-xs"></i>
                        <i *ngIf="star === 'empty'" class="pi pi-star text-gray-300 text-xs"></i>
                    </ng-container>
                </div>
                <div class="text-xs text-gray-500 text-center mt-1">Avg rating</div>
            </div>

            <!-- Bob thumbs up -->
            <div class="rounded-lg bg-gray-50 p-3 flex flex-col items-center justify-center outline outline-1 outline-gray-100">
                <i class="pi pi-thumbs-up text-emerald-500 text-base"></i>
                <div class="text-lg font-bold text-gray-900 mt-1">{{ data()?.bobThumbsUpPct ?? 0 }}%</div>
                <div class="text-xs text-gray-500 text-center">Bob thumbs up</div>
            </div>

            <!-- Dismiss rate -->
            <div class="rounded-lg bg-gray-50 p-3 flex flex-col items-center justify-center outline outline-1 outline-gray-100">
                <i class="pi pi-times-circle text-rose-400 text-base"></i>
                <div class="text-lg font-bold text-gray-900 mt-1">{{ data()?.dismissRatePct ?? 0 }}%</div>
                <div class="text-xs text-gray-500 text-center">Dismiss rate</div>
            </div>

            <!-- Placeholder cell to balance grid on sm widths -->
            <div class="hidden sm:block"></div>
        </div>

        <!-- Per-feature horizontal bars -->
        <div class="flex flex-col gap-2 min-w-0">
            <div class="text-xs font-semibold text-gray-600 mb-1">Positive sentiment by feature</div>
            <div *ngFor="let feature of data()?.perFeature" class="min-w-0">
                <div class="flex items-center justify-between text-xs text-gray-600 min-w-0 gap-2">
                    <span class="truncate">{{ feature.name }}</span>
                    <span class="font-semibold text-gray-900 flex-shrink-0">{{ feature.positivePct }}%</span>
                </div>
                <div class="w-full h-2 bg-gray-100 rounded-full overflow-hidden mt-1">
                    <div class="h-full bg-emerald-400 rounded-full" [style.width.%]="feature.positivePct"></div>
                </div>
            </div>
        </div>
    </div>
</div>
